import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-950 mb-3">
              {contactData.title}
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              {contactData.description}
            </p>
          </div>

          <div className="max-w-2xl mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
              <div className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-800 mb-1">电子邮箱</h3>
                <p className="text-sm text-foreground-500 break-all">{contactData.email}</p>
              </div>

              <div className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                  <i className="ri-wechat-line text-xl text-accent-500"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-800 mb-1">微信公众号</h3>
                <p className="text-sm text-foreground-500">{contactData.wechat}</p>
              </div>

              <div className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-secondary-100 flex items-center justify-center">
                  <i className="ri-qq-line text-xl text-secondary-500"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-800 mb-1">QQ群</h3>
                <p className="text-sm text-foreground-500">{contactData.qq}</p>
              </div>

              <div className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-time-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-800 mb-1">工作时间</h3>
                <p className="text-sm text-foreground-500">{contactData.workingHours}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}